import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/life/us/a-sticky-header-check-our-prices';
import { LifePageTemplate } from '@/pageTemplate/LifePageTemplate';
import { Cookie } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

export default function LifePage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  const [cookies] = useCookies([Cookie.UUID]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(() => {
    trackEventWithGeolocation('life_page.viewed', {
      product: 'life',
      client_uuid: cookies[Cookie.UUID],
      experiment: 'a-sticky-header-check-our-prices',
    });
  }, [cookies]);

  return <LifePageTemplate config={config} />;
}
